import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/sales-order/{id}/submit`。DRAFT → PREPARING。body：`updatedAt`。 */
export async function submitSalesOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/sales-order/${id}/submit`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
